import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';

import Badge from 'components/Badge';

RecurrenceDisplay.propTypes = {
    recurrence: PropTypes.number.isRequired,
    recurrenceUnit: PropTypes.string.isRequired,
    lastImportedAt: PropTypes.string,
};

const UNIT_MS = {
    min: 60 * 1000,
    hour: 60 * 60 * 1000,
    day: 24 * 60 * 60 * 1000,
};

const dateFormatter = new Intl.DateTimeFormat('sv-SE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
});

function RecurrenceDisplay({recurrence, recurrenceUnit, lastImportedAt}) {
    const intl = useIntl();

    if (recurrence === 0) {
        return <Badge color={'default'}>{intl.formatMessage({id: 'feed.list.table.recurrence_disabled'})}</Badge>;
    }

    let nextImport = '—';

    if (lastImportedAt) {
        const next = new Date(new Date(lastImportedAt).getTime() + recurrence * UNIT_MS[recurrenceUnit]);
        const display = next < new Date() ? new Date() : next;
        nextImport = dateFormatter.format(display);
    }

    return (
        <div style={{fontSize: '13px', color: '#374151'}}>
            {intl.formatMessage(
                {id: `feed.list.table.recurrence_${recurrenceUnit}`},
                {count: recurrence !== 1 && recurrence, nextImport}
            )}
        </div>
    );
}

export default RecurrenceDisplay;
